<div>
	{{ "forgotpassword.change" | translate }}.
	<br>
</div>
<form [formGroup]="form" (ngSubmit)="forgotPasswordChange()" novalidate class="sdp-forgot-password-form">
	<div class="sdp-form-control">
		<mat-form-field class="sdp-form-control-input-container">
			<input matInput placeholder="{{'form.label.newPassword' | translate}}" type="{{ passwordType }}" formControlName="password">
		</mat-form-field>
		<div class="sdp-password-show" [class.sdp-text-input]="passwordType==='text'">
			<sdp-icon [icon]="passwordIcon" (click)="passwordType = passwordType==='text'?'password':'text'"></sdp-icon>
		</div>
		<div class="sdp-password-strength-container">
			<ng2-password-strength-bar [passwordToCheck]="form.get('password')!.value" barLabel="{{ 'password.strength.label' | translate }}"></ng2-password-strength-bar>
		</div>
	</div>
	<div class="sdp-form-control">
		<mat-form-field class="sdp-form-control-input-container">
			<input matInput placeholder="{{ 'form.label.confirmNewPassword' | translate }}" type="{{ passwordType }}" formControlName="confirmPassword">
			<mat-error *ngIf="form.controls['confirmPassword'].hasError('confirmNoMatch')">{{ "error.form.passwordDoNotMatch" | translate }}.</mat-error>
		</mat-form-field>
	</div>
	<div class="sdp-form-buttons-container">
		<button class="sdp-button-small-text" type="button" color="primary" mat-button (click)="back()">{{ "sdp.label.cancel" | translate }}</button>
		<button color="primary" type="submit" mat-raised-button>{{ "form.label.resetPassword" | translate }}</button>
	</div>
</form>